export default __webpack_public_path__ + "static/media/hibernate.0db12894.png";